// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const zeraora: PokeData = {
  "id": 807,
  "name": "zeraora",
  "height": 15,
  "weight": 445,
  "base_experience": 270,
  "types": [
    PokeType.ELECTRIC
  ],
  "api_moves": [
    "thunder-punch",
    "scratch",
    "agility",
    "quick-attack",
    "fury-swipes",
    "slash",
    "spark",
    "fake-out",
    "charge",
    "close-combat",
    "discharge",
    "hone-claws",
    "quick-guard",
    "volt-switch",
    "wild-charge",
    "snarl",
    "power-up-punch",
    "plasma-fists"
  ],
  "moves": [
    "thunder-punch",
    "scratch",
    "quick-attack",
    "close-combat",
    "volt-switch",
    "wild-charge",
    "snarl",
    "quick-tempo",
    "electric-terrain",
    "volt-crash",
    "thunder-shock",
    "zap-cannon",
    "thunderbolt"
  ],
  "evolution_chain": {
    "id": 427,
    "item": null,
    "species": [
      {
        "name": "zeraora",
        "order": 807,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 98,
    "speed": 169,
    "ability_power": 133
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": false,
  "is_mythical": true,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
